/* eslint-disable react/jsx-no-target-blank */
import React, { Fragment, useState, useEffect } from "react";
import API from "@unisearch/helpers/api";
import { Grid, Skeleton } from "@mui/material";

import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import { getAssets } from "@unisearch/helpers";
import moment from "moment";
import Link from "next/link";
import styles from "./recommended.module.scss";
import Image from "next/legacy/image";

const VlogRecommended = ({ vlogDetails, keyword, id }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await API.get(
          `/public/vlog/recommendation?keyword=${keyword}&limit=5`
        );
        setLoading(false);
        const data = res?.data.filter((item) => item.id != id);
        setData(data);
      } catch (error) {
        setLoading(false);
        setError("Something went wrong");
      }
    };
    fetchData();
  }, []);

  return (
    <Fragment>
      {data?.length > 0 ? (
        <>
          {" "}
          <div className={styles.recomended_video}>
            <h2>Recomended Videos</h2>
            <ul>
              {data &&
                data?.length > 0 &&
                data?.map((item, i) => (
                  <li key={i} title={item?.title}>
                    <div className={styles.image_wrapper} title={item?.title}>
                      <Image
                        layout="responsive"
                        width={135}
                        height={86}
                        blurDataURL={getAssets(
                          "assets/images/image_placeholder_big.webp"
                        )}
                        placeholder="blur"
                        className=""
                        src={
                          item?.featuredImage?.src ||
                          getAssets("assets/images/video_placeholder_big.png")
                        }
                        alt={item?.title}
                      />
                      <PlayButtonWithRipple small ripple={false} />
                    </div>
                    <div className={styles.details_wrapper}>
                      <Link
                        legacyBehavior
                        href={`/vlog/${item?.slug}`}
                        title={item?.title}
                      >
                        <a className={styles.title}>{item?.title}</a>
                      </Link>
                      <div className={styles.sub_title}>
                        {item?.totalView} Views ●{" "}
                        {moment(item?.publishedDate).format("MMMM DD, YYYY")}
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

export default VlogRecommended;
